module.exports = "/_next/static/images/02f608fef03870badffd8c01998c31f5-cuenta-card-xs.png";